:host {
}

.stzh-socialmediastream {
  &__items {
    position: relative;
  }

  &__heading {
    @include spaceCurve('margin-bottom', 'small');
  }

  &__item {
    position: absolute;
  }
}
